import React from 'react';

const PLATFORMS = [
  { name: 'All', id: 'all' },
  { name: 'Netflix', id: 'netflix' },
  { name: 'Prime Video', id: 'prime' },
  { name: 'Apple TV+', id: 'appletv' },
  { name: 'Hulu', id: 'hulu' },
  { name: 'Disney+', id: 'disney' },
  { name: 'HBO Max', id: 'hbo' }
];

const PlatformFilter = ({ selectedPlatform, onPlatformChange }) => {
  return (
    <div className="flex flex-wrap gap-3" data-testid="platform-filter">
      {PLATFORMS.map((platform) => (
        <button
          key={platform.id}
          data-testid={`filter-${platform.id}`}
          onClick={() => onPlatformChange(platform.name)}
          className={`px-4 py-2 rounded-full border transition-all text-sm font-mono uppercase tracking-wider
            ${selectedPlatform === platform.name
              ? 'bg-black text-white border-black'
              : 'border-gray-700 bg-white text-black hover:border-black'
            }
          `}
        >
          {platform.name}
        </button>
      ))}
    </div>
  );
};

export default PlatformFilter;
